import { Component, OnInit, Input, Output, forwardRef, EventEmitter, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor,FormGroup, FormControl, Validators } from '@angular/forms';
import { es } from 'date-fns/locale';
import { SearchCountryField } from './ngx-intl-tel-input/enums/search-country-field.enum';
import { CountryISO } from './ngx-intl-tel-input/enums/country-iso.enum';
import { PhoneNumberFormat } from './ngx-intl-tel-input/enums/phone-number-format.enum';

@Component({
    selector: 'dhs-intl-tel-input',
    templateUrl: './intl-tel-input.component.html',
    styleUrls: ['./intl-tel-input.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: IntlTelInputComponent,
            multi: true,
        }],
    standalone: false
})
export class IntlTelInputComponent implements ControlValueAccessor, OnInit {
    @Input() question: any;
    @Input('value') _value: any;
    @Input() msgFromParent1: any;
    @Output() valueChange = new EventEmitter<any>();
    propagateChange = (_: any) => { };
    onTouched: any = () => { };
    dialCode: any;
    phone:any;

    // separateDialCode = true;
    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO;
    preferredCountries: any ;
    selectedCountryISO: any;
    PhoneNumberFormat = PhoneNumberFormat;

    // separateDialCode = true;
    // SearchCountryField = SearchCountryField;
    // CountryISO = CountryISO;
    // PhoneNumberFormat = PhoneNumberFormat;
    // preferredCountries: CountryISO[] = [CountryISO.India];
    phoneForm = new FormGroup({
      phone: new FormControl(undefined, [Validators.required])
    });
    public clicked: boolean = false;
    constructor() {
    }
    ngDoCheck(changes) {
      if(this.question && this.question.selectedCountryISO != undefined){
        this.selectedCountryISO = this.question.selectedCountryISO;
      }
      else{
        console.log("inside");
        
        this.selectedCountryISO = "in";
      }
      console.log("selectedCountryISO", this.question.selectedCountryISO);
  }
    ngOnInit() {
      // this.setvalueForUpdate(this.value);
      if(this.question && this.question.preferredCountries != undefined){
        this.preferredCountries = [this.question.preferredCountries];
      }
      else{
        this.preferredCountries = ["in"];
      }
      if(this.question && this.question.selectedCountryISO != undefined){
        this.selectedCountryISO = this.question.selectedCountryISO;
      }
      else{
        this.selectedCountryISO = "in";
      }
    }
  
    changeValue(event) {
      // Format:
      // {
      //   "phone": {
      //     "number": "099999 99999",
      //     "internationalNumber": "+91 99999 99999",
      //     "nationalNumber": "099999 99999",
      //     "e164Number": "+919999999999",
      //     "countryCode": "IN",
      //     "dialCode": "+91"
      //   }
      // }
      this.clicked = true;

    if(this.phoneForm.valid){
      this.clicked = false;
    }
      if((this.question.numberFormate != undefined && this.question.numberFormate != "") && (this.phoneForm != undefined && this.phoneForm.value !=null && this.phoneForm.value.phone != null)){
        console.log("countryCode::",this.phoneForm.value.phone.countryCode);
        this.value = this.phoneForm.value.phone[this.question.numberFormate];
      }
      else{
        console.log("countryCode::IN")
        this.value  = Number(event.target.value)
      }
      this.valueChange.emit(this.value);
    }
  
    get value(): any {
      return this._value;
    }
  
    set value(val) {
      this._value = val;
      this.propagateChange(val);
      this.onTouched();
    }
  
    writeValue(value) {
      if (value) {
        this.value = value;
        this.setvalueForUpdate(this.value);
      }
      this.propagateChange(value);
    }
  
    setvalueForUpdate(value){
      if (value) {
        this.value = value;
        this.phone = this.value;
      }
    }
    registerOnChange(fn: any) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
  }